import { analyticsTrackEvent } from '../../utils/analytics';
import { MATERIALS_EDIT_FOLDER } from '../../constants/analytics';
import {
  UpdateFolderBody,
  UpdateFolderContract,
} from '@ublend-npm/aula-schema/types/materials';
import { CLASSROOM_MATERIAL_FOLDER } from '../../constants/endpoints';
import request, { getData } from './request';
import toFolder from './toFolder';

const patchFolder = async (
  classRoomId: string,
  folderId: string,
  patch: UpdateFolderBody,
  correlationId?: string,
  educatorOnly?: boolean,
  isRbacEnabled: boolean = false
) => {
  const url = CLASSROOM_MATERIAL_FOLDER(classRoomId, folderId, educatorOnly);
  const data = await request<UpdateFolderContract>({
    method: 'patch',
    url,
    data: { folder: patch },
  }).then(getData);
  try {
    analyticsTrackEvent(MATERIALS_EDIT_FOLDER, {
      itemId: data.id,
      spaceId: data.space,
      scheduledFor: patch.scheduledFor ?? '',
      itemType: 'Material',
      isRbacEnabled,
    });
  } catch {
    // Analytics must not turn a successful API request into a failed action.
  }
  return toFolder(data);
};

export default patchFolder;
